(function () {
  if (window.__vpCartDiscountInit) return;
  window.__vpCartDiscountInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function stringsFor(rootEl) {
    return {
      applied: (rootEl && rootEl.getAttribute('data-msg-applied')) || 'Discount applied',
      invalid: (rootEl && rootEl.getAttribute('data-msg-invalid')) || 'Enter a valid discount code',
      error: (rootEl && rootEl.getAttribute('data-msg-error')) || 'Could not apply discount code',
      removed: (rootEl && rootEl.getAttribute('data-msg-removed')) || 'Discount removed'
    };
  }

  function money(cents) {
    try {
      if (window.themeCurrency && typeof themeCurrency.formatMoney === 'function' && window.theme && theme.moneyFormat) {
        var formatted = themeCurrency.formatMoney(cents, theme.moneyFormat);
        if (theme.currencyCode) formatted += ' ' + theme.currencyCode;
        return formatted;
      }
    } catch (e) {}
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return (Number(cents || 0) / 100).toFixed(2);
  }

  function cartUrl(path) {
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function getRoots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-vp-cart-discount]'));
  }

  function setStatus(rootEl, message, type) {
    var el = rootEl.querySelector('[data-vp-discount-status]');
    if (!el) return;
    if (!message) {
      el.hidden = true;
      el.textContent = '';
      el.removeAttribute('data-state');
      return;
    }
    el.hidden = false;
    el.textContent = message;
    el.setAttribute('data-state', type || 'info');
  }

  function setBusy(rootEl, busy) {
    var apply = rootEl.querySelector('[data-vp-discount-apply]');
    var remove = rootEl.querySelector('[data-vp-discount-remove]');
    var input = rootEl.querySelector('[data-vp-discount-input]');
    if (apply) apply.disabled = !!busy;
    if (remove) remove.disabled = !!busy;
    if (input) input.disabled = !!busy;
  }

  function isWpdReady() {
    return !!(
      window.wcp_data &&
      window.wcp_data.wcp_cart &&
      typeof window.wcpCheckCart === 'function' &&
      typeof window.setCookie === 'function'
    );
  }

  function wpdToken() {
    try {
      return window.wcp_data.wcp_cart.token;
    } catch (e) {
      return null;
    }
  }

  function waitForWpd(timeoutMs) {
    return new Promise(function (resolve) {
      if (isWpdReady()) return resolve(true);
      var start = Date.now();
      var timer = setInterval(function () {
        if (isWpdReady()) {
          clearInterval(timer);
          resolve(true);
        } else if (Date.now() - start > (timeoutMs || 8000)) {
          clearInterval(timer);
          resolve(false);
        }
      }, 150);
    });
  }

  function appliedCodes(cart) {
    if (!cart) return [];
    var codes = [];
    if (Array.isArray(cart.discount_codes)) {
      cart.discount_codes.forEach(function (entry) {
        if (entry && entry.code && entry.applicable !== false) codes.push(String(entry.code));
      });
    }
    // Shopify's automatic discounts are retail-only: WPD swaps a mayorista cart
    // for a draft order at its own prices, so the 5% never reaches the invoice.
    // Advertising it here promised $71.60 that checkout did not honour. Typed
    // codes above and WPD's own coupons (syncFromWpd) are unaffected.
    if (!codes.length && window.is_wcp_wholesale_customer === true) return codes;
    if (!codes.length && Array.isArray(cart.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach(function (d) {
        if (d && d.title) codes.push(String(d.title));
      });
    }
    return codes;
  }

  function syncUI(cart) {
    var codes = appliedCodes(cart);
    var totalDiscount = Number(cart && cart.total_discount) || 0;

    getRoots().forEach(function (rootEl) {
      var appliedWrap = rootEl.querySelector('[data-vp-discount-applied]');
      var appliedText = rootEl.querySelector('[data-vp-discount-applied-text]');
      var input = rootEl.querySelector('[data-vp-discount-input]');

      if (codes.length) {
        if (appliedWrap) appliedWrap.hidden = false;
        if (appliedText) {
          var label = codes.join(', ');
          if (totalDiscount > 0) label += ' (−' + money(totalDiscount) + ')';
          appliedText.textContent = label;
        }
        if (input && !input.value) input.value = codes[0];
      } else if (appliedWrap && !rootEl.querySelector('.DiscointCodeSuccess')) {
        appliedWrap.hidden = true;
      }
    });

    if (cart && typeof cart.total_price !== 'undefined') {
      // Always sync checkout button — WPD-ready used to skip this and leave pre-discount totals
      document.querySelectorAll('[data-cart-final]').forEach(function (node) {
        node.textContent = money(cart.total_price);
      });
    }
  }

  function syncFromWpd(rootEl, strings) {
    var hash = window.wcp_data && window.wcp_data.discounted_hash;
    var item = rootEl.querySelector('[data-vp-wcp-discount-item], .wcp-discount-item');
    var appliedWrap = rootEl.querySelector('[data-vp-discount-applied]');
    var appliedText = rootEl.querySelector('[data-vp-discount-applied-text]');
    var input = rootEl.querySelector('[data-vp-discount-input]');

    if (hash && hash.show_discount_code && window.wcp_data.discount_code) {
      if (input) input.value = window.wcp_data.discount_code;
      if (hash.ApplyDiscountCode) {
        setStatus(rootEl, strings.applied, 'success');
        if (appliedWrap) appliedWrap.hidden = false;
        if (appliedText) {
          var amt = hash.discountCodeamount != null ? String(hash.discountCodeamount) : '';
          var cur = hash.currency || '';
          if (String(cur).indexOf('&') !== -1) {
            var ta = document.createElement('textarea');
            ta.innerHTML = cur;
            cur = ta.value || '$';
          }
          appliedText.textContent = window.wcp_data.discount_code + (amt ? ' (−' + cur + amt + ')' : '');
        }
        return true;
      }
      if (item && item.textContent) {
        setStatus(rootEl, item.textContent.trim() || strings.invalid, 'error');
      } else {
        setStatus(rootEl, strings.invalid, 'error');
      }
      return false;
    }

    if (item && item.classList.contains('DiscointCodeSuccess')) {
      setStatus(rootEl, strings.applied, 'success');
      return true;
    }
    if (item && item.classList.contains('DiscointCodeInvalid')) {
      setStatus(rootEl, (item.textContent || strings.invalid).trim(), 'error');
      return false;
    }
    return null;
  }

  function refreshTheme(cart) {
    document.dispatchEvent(
      new CustomEvent('theme:cart:change', {
        detail: { cart: cart },
        bubbles: true
      })
    );
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
  }

  function fetchCart() {
    return fetch(cartUrl('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('cart');
      return res.json();
    });
  }

  function updateDiscount(code) {
    return fetch(cartUrl('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: code || '' })
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) {
          var err = new Error((json && (json.description || json.message)) || 'update');
          err.payload = json;
          throw err;
        }
        return json;
      });
    });
  }

  function codeWasApplied(cart, code) {
    if (!code) return true;
    var needle = String(code).trim().toLowerCase();
    if (Array.isArray(cart.discount_codes)) {
      return cart.discount_codes.some(function (entry) {
        return entry && entry.code && String(entry.code).toLowerCase() === needle && entry.applicable !== false;
      });
    }
    return Number(cart.total_discount) > 0;
  }

  function applyViaWpd(rootEl, code, strings) {
    var token = wpdToken();
    if (token == null || token === undefined) {
      setStatus(rootEl, strings.error, 'error');
      setBusy(rootEl, false);
      return;
    }

    window.setCookie('wcp_discount_' + token, code);
    window.wcp_data.discount_code = code;

    try {
      window.wcpCheckCart(window.wcp_data);
    } catch (e) {
      setStatus(rootEl, strings.error, 'error');
      setBusy(rootEl, false);
      return;
    }

    // WPD updates DOM async after AJAX — poll briefly for result
    var tries = 0;
    var poll = setInterval(function () {
      tries += 1;
      var result = syncFromWpd(rootEl, strings);
      if (result === true || result === false || tries > 20) {
        clearInterval(poll);
        setBusy(rootEl, false);
        if (result === null) setStatus(rootEl, strings.applied, 'success');
        fetchCart()
          .then(function (cart) {
            refreshTheme(cart);
          })
          .catch(function () {});
      }
    }, 250);
  }

  function removeViaWpd(rootEl, strings) {
    var token = wpdToken();
    if (token == null || token === undefined) {
      setStatus(rootEl, strings.error, 'error');
      setBusy(rootEl, false);
      return;
    }
    window.setCookie('wcp_discount_' + token, '');
    window.wcp_data.discount_code = '';
    try {
      window.wcpCheckCart(window.wcp_data);
    } catch (e) {
      setStatus(rootEl, strings.error, 'error');
      setBusy(rootEl, false);
      return;
    }
    var input = rootEl.querySelector('[data-vp-discount-input]');
    if (input) input.value = '';
    var appliedWrap = rootEl.querySelector('[data-vp-discount-applied]');
    if (appliedWrap) appliedWrap.hidden = true;
    setStatus(rootEl, strings.removed, 'success');
    setBusy(rootEl, false);
    fetchCart()
      .then(function (cart) {
        refreshTheme(cart);
      })
      .catch(function () {});
  }

  function applyFrom(rootEl) {
    var strings = stringsFor(rootEl);
    var input = rootEl.querySelector('[data-vp-discount-input]');
    var code = input ? String(input.value || '').trim() : '';
    if (!code) {
      setStatus(rootEl, strings.invalid, 'error');
      return;
    }

    setBusy(rootEl, true);
    setStatus(rootEl, '', null);

    waitForWpd(2500).then(function (ready) {
      if (ready) {
        applyViaWpd(rootEl, code, strings);
        return;
      }

      // Retail / non-WPD path
      updateDiscount(code)
        .then(function () {
          return fetchCart();
        })
        .then(function (cart) {
          syncUI(cart);
          refreshTheme(cart);
          if (codeWasApplied(cart, code)) {
            setStatus(rootEl, strings.applied, 'success');
          } else {
            setStatus(rootEl, strings.invalid, 'error');
          }
        })
        .catch(function (err) {
          setStatus(rootEl, (err && err.message) || strings.error, 'error');
        })
        .finally(function () {
          setBusy(rootEl, false);
        });
    });
  }

  function removeFrom(rootEl) {
    var strings = stringsFor(rootEl);
    setBusy(rootEl, true);
    setStatus(rootEl, '', null);

    waitForWpd(1500).then(function (ready) {
      if (ready) {
        removeViaWpd(rootEl, strings);
        return;
      }

      updateDiscount('')
        .then(function () {
          return fetchCart();
        })
        .then(function (cart) {
          var input = rootEl.querySelector('[data-vp-discount-input]');
          if (input) input.value = '';
          syncUI(cart);
          refreshTheme(cart);
          setStatus(rootEl, strings.removed, 'success');
        })
        .catch(function (err) {
          setStatus(rootEl, (err && err.message) || strings.error, 'error');
        })
        .finally(function () {
          setBusy(rootEl, false);
        });
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var applyBtn = event.target.closest('[data-vp-discount-apply]');
      if (applyBtn) {
        // Let WPD's own jQuery handler also run when present; we still drive UX.
        event.preventDefault();
        var rootApply = applyBtn.closest('[data-vp-cart-discount]');
        if (rootApply) applyFrom(rootApply);
        return;
      }

      var removeBtn = event.target.closest('[data-vp-discount-remove]');
      if (removeBtn) {
        event.preventDefault();
        var rootRemove = removeBtn.closest('[data-vp-cart-discount]');
        if (rootRemove) removeFrom(rootRemove);
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest('[data-vp-discount-input]');
    if (!input) return;
    event.preventDefault();
    var rootEl = input.closest('[data-vp-cart-discount]');
    if (rootEl) applyFrom(rootEl);
  });

  document.addEventListener('theme:cart:change', function (event) {
    if (event.detail && event.detail.cart) syncUI(event.detail.cart);
  });

  document.addEventListener('theme:drawer:open', function () {
    fetchCart()
      .then(syncUI)
      .catch(function () {});
    waitForWpd(5000).then(function (ready) {
      if (!ready) return;
      getRoots().forEach(function (rootEl) {
        syncFromWpd(rootEl, stringsFor(rootEl));
      });
    });
  });

  if (document.querySelector('[data-vp-cart-discount]')) {
    fetchCart()
      .then(syncUI)
      .catch(function () {});
  }
})();
